<script setup lang="ts">
import Tags from '../shared/Tags.vue'

import type { RelatedTagsParagraph } from '../../utils/paragraph-schema/paragraphs'

defineProps<{
  title?: RelatedTagsParagraph['relatedTags']['title']
  tags?: RelatedTagsParagraph['relatedTags']['tags']
}>()
</script>

<template>
  <Tags v-if="tags?.length"
        :class="['bx-content', 'bx-typo--content-related-tags']"
        :title="title"
        :tags="tags" />
</template>
